import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AIShowcase.css';

const conversations = [
  {
    id: 'coach',
    title: 'Personal Coaching',
    messages: [
      { type: 'user', text: "I've been stuck at the same weight for 2 weeks. What's going on?" },
      { type: 'ai', text: "I've analyzed your recent data. A few things stand out:\n\n1. Your weekend calories average 2,400 vs 1,800 on weekdays\n2. You've skipped your last 3 scheduled leg days\n3. Your protein intake dropped to 95g avg (was 140g)\n\nLet's focus on consistency. Want me to adjust your meal plan for weekends?" }
    ]
  },
  {
    id: 'workout',
    title: 'Workout Generation',
    messages: [
      { type: 'user', text: "Create a workout for today. I only have 30 minutes and dumbbells." },
      { type: 'ai', text: "Based on your split, today should be upper body. Here's a 30-min dumbbell workout:\n\nWarm-up (3 min)\nDB Press 3x10\nDB Rows 3x10 each\nShoulder Press 3x12\nBicep Curls 2x15\nTricep Extensions 2x15\n\nI've added this to your schedule. Ready to start?" }
    ]
  },
  {
    id: 'food',
    title: 'Food Logging',
    messages: [
      { type: 'user', text: "Just had a burrito bowl with chicken, rice, black beans, salsa, and guac" },
      { type: 'ai', text: "Logged your burrito bowl:\n\nCalories: 685\nProtein: 42g\nCarbs: 68g\nFat: 24g\n\nGreat protein choice. You're at 1,420 calories today with 98g protein. You have room for a 380 cal dinner to hit your targets." }
    ]
  }
];

function AIShowcase() {
  const [activeTab, setActiveTab] = useState('coach');
  const activeConvo = conversations.find(c => c.id === activeTab);

  return (
    <section id="ai-coach" className="ai-showcase">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <h2>See the AI in Action</h2>
          <p>Real conversations, real insights. Your AI coach understands context and provides actionable guidance.</p>
        </motion.div>

        <motion.div 
          className="showcase-container"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="showcase-tabs">
            {conversations.map(convo => (
              <button
                key={convo.id}
                className={`tab-btn ${activeTab === convo.id ? 'active' : ''}`}
                onClick={() => setActiveTab(convo.id)}
              >
                {convo.title}
              </button>
            ))}
          </div>

          <div className="showcase-chat">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                className="chat-content"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                {activeConvo.messages.map((msg, i) => (
                  <div key={i} className={`showcase-message ${msg.type}`}>
                    {msg.type === 'ai' && (
                      <div className="ai-badge">
                        <svg viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
                          <circle cx="12" cy="12" r="3" fill="currentColor"/>
                        </svg>
                        AI Coach
                      </div>
                    )}
                    <p style={{ whiteSpace: 'pre-line' }}>{msg.text}</p>
                  </div>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default AIShowcase;
